var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DescriptionSection',[(_vm.service.additionalInfo)?_c('DescriptionItem',{attrs:{"title":"Dodatkowe informacje","value":_vm.service.additionalInfo}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }